/**
 * Room.js
 * 
 * This is the main AuctionRoom
 * 
 * Has different pages for the people to view.
 * 1. Select Room page (sessionID = ''); users can start a new room.
 * 2. 
 * 
 * (Future) update this for people to have their own lists and contraints and bonus points
 * Make this into a complete game
 */
import React from "react";
import RoomEntryBox from "../../Rooms/components/RoomEntryBox";
import { AuctionRoomsCollection } from "../../assets/DatabaseCollections";
import { useClientAuth } from "../../hooks/clientAuth";
import { useNavigate } from "react-router-dom";
import { setUpAuctionRoom } from "./helpers/auctionLobby";

const AuctionGame = () => {
    const { user } = useClientAuth();
    const navigate = useNavigate();

    const setRoom = (room) => {
        navigate(`/auction/${room}`);
    }

    // User check (placeholder; replace with your actual auth context)
    if (!user) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-black text-zinc-100">
                <p className="text-lg font-medium">Please login first to continue.</p>
            </div>
        );
    }

    return (
        <div className={`min-h-screen flex flex-col items-center justify-center bg-black`}>
            <RoomEntryBox
                setRoom={setRoom}
                user={user}
                dbCollection={AuctionRoomsCollection}
                gameName="Auction"
                onRoomCreated={(room) => setUpAuctionRoom(room.id)}
            />
        </div>
    );
};

export default AuctionGame;